<script>
// Options API / Single File Component as it contains styles, template and logic within a single Vue File
import axios from "axios";

// @TODO - Ensure we utilize the best/latest data from API via Wordpress
// @TODO - Ensure we add handling/conditions for loading/error states
// @TODO - Add logic/handling for what map to utilize
// @TODO - Ensure we call the API if for some reason the data isn't available anymore
  export default {
    mounted(){
      // @TODO - Switch to API call from Sync for redundant backup, and use the direct data load for initial, but this will at least get us MVP in the interim
      //this.getStore();
      //console.log(window.store_meta_data);
      if(window.store_meta_data){
        this.assignStoreData();
        //this.store = window.store_meta_data;
        this.checkActiveStore();
      }
      if(window.store_api_data){
        this.mapApiData(window.store_api_data);
      } else {
        if(this.store.store_id){
          this.getApiData();
        }
      }
    },
    /*
    watch: {
      'store.store_id'(){
        // could pass newVal with INT?
          this.getApiData();
      }
    },
     */
    methods: {
      // @TODO - Add @click handler to quote buttons and create method to trigger the modal opening onclick call through Vue
      assignStoreData(){
        const vm = this;
        let data = window.store_meta_data;
        Object.entries(data).forEach(function([$key,$value]){
          vm.store[$key] = $value;
        });
      },
      checkActiveStore(){
        // Check Cookie for userTwStore
        // If has -> process against data
        if(this.getCookie('userTwStore')){
          let store_id = parseInt(this.getCookie('userTwStore'));
          if(store_id === parseInt(this.store.store_id)){
            this.my_store = true;
          }
        }
      },
      getCookie(cname){
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return false;
      },
      setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        let expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
      },
      openQuoteModal(){
        if(typeof(window.tintworldVue) !== 'undefined' && typeof(window.tintworldVue.$root) !== 'undefined'){
          window.tintworldVue.$root.$store.commit('OpenModal','quote');
          window.tintworldVue.$root.$emit('bv::show::modal','tint-world-modal');
        }
      },
      setMyStore(){
        if(typeof(window.tintworldVue) !== 'undefined' && typeof(window.tintworldVue.$root) !== 'undefined'){
          this.my_store = true;
          window.tintworldVue.$root.$children[0].updateStoreLocation(this.store.store_id);
          this.setCookie('userTwStore',this.store.store_id, 7);
        }
      },
      mapApiData(data){
        const vm = this;
        if(data.attributes){
          if(typeof(data.attributes.street_2) !== 'undefined'){
            vm.store.address2 = data.attributes.street_2;
          }
          if(typeof(data.attributes.google_place_id) !== 'undefined' && data.attributes.google_place_id.length != ''){
            vm.store.google_place = data.attributes.google_place_id;
          }
          if(typeof(data.attributes.store_display_number) !== 'undefined'){
            vm.store.display_phone = data.attributes.store_display_number;
          }
          if(typeof(data.attributes.facebook_url) !== 'undefined'){
            vm.store.facebook_url = data.attributes.facebook_url;
          }
          if(typeof(data.attributes.instagram_url) !== 'undefined'){
            vm.store.instagram_url = data.attributes.instagram_url;
          }
          if(typeof(data.attributes.landing_page_url) !== 'undefined'){
            vm.store.store_url = data.attributes.landing_page_url;
          }
          if(typeof(data.attributes.map_image) !== 'undefined'){
            vm.store.map_image = data.attributes.map_image;
          }
          if(typeof(data.attributes.store_phone) !== 'undefined'){
            vm.store.phone_international = data.attributes.store_phone;
          }
          if(typeof(data.attributes.latitude) !== 'undefined'){
            vm.store.latitude = data.attributes.latitude;
          }
          if(typeof(data.attributes.longitude) !== 'undefined'){
            vm.store.longitude = data.attributes.longitude;
          }
        }
      },
      getApiData(){
        const vm = this;
        let store_id;
        if(vm.store.franconnect_id !== null){
          store_id = vm.store.franconnect_id;
        }
        if(vm.store.store_id !== null){
          store_id = vm.store.store_id;
        }
        if(typeof(store_id) == 'undefined'){
          return false;
        }
        axios.get('https://sync.tintworld.com/api/v4/store/'+parseInt(store_id), {
      }).then(function(response) {
          let data = response.data.data;
          if(data.attributes){
            if(typeof(data.attributes.street_2) !== 'undefined'){
              vm.store.address2 = data.attributes.street_2;
            }
            if(typeof(data.attributes.google_place_id) !== 'undefined'){
              vm.store.google_place = data.attributes.google_place_id;
            }
            if(typeof(data.attributes.store_display_number) !== 'undefined'){
              vm.store.display_phone = data.attributes.store_display_number;
            }
            if(typeof(data.attributes.facebook_url) !== 'undefined'){
              vm.store.facebook_url = data.attributes.facebook_url;
            }
            if(typeof(data.attributes.instagram_url) !== 'undefined'){
              vm.store.instagram_url = data.attributes.instagram_url;
            }
            if(typeof(data.attributes.landing_page_url) !== 'undefined'){
              vm.store.store_url = data.attributes.landing_page_url;
            }
            if(typeof(data.attributes.map_image) !== 'undefined'){
              vm.store.map_image = data.attributes.map_image;
            }
            if(typeof(data.attributes.store_phone) !== 'undefined'){
              vm.store.phone_international = data.attributes.store_phone;
            }
            if(typeof(data.attributes.latitude) !== 'undefined'){
              vm.store.latitude = data.attributes.latitude;
            }
            if(typeof(data.attributes.longitude) !== 'undefined'){
              vm.store.longitude = data.attributes.longitude;
            }
          }
        });
      },
      myStoreToggle(){
        this.my_store = true;
        this.setMyStore();
      }
    },
    data(){
      return {
        store: {
          post_id: null,
          franconnect_id: null,
          store_id: null,
          store_url: null,
          address: null,
          address2: null,
          city: null,
          state: null,
          phone: null, // set as default 1-800 number
          region_code: null,
          full_address: null,
          postal_code: null,
          google_place: null,
          hours: 'Mon - Sat: 8am - 6pm <br/> <div class="em">Closed Sundays</div>',
          store_tour: null,
          local_areas: null,
          display_phone: null,
          instagram_url: null,
          facebook_url: null,
          map_image: null,
          phone_international: null,
          latitude: null,
          longitude: null
        },
        toggle: false,
        my_store: false,
      }
    },
    computed: {
      showToggle(){
        if(this.hasStoreTour){
          return true;
        }
        return false;
      },
      fullAddress(){
        if(this.store.full_address !== null){
          return this.store.full_address;
        }
        if(this.store.address !== null){
          return this.store.address + ' '+ this.store.address2+ ' '+ this.store.city + ', '+ this.store.state + ' '+ this.store.postal_code;
        }
        return ''
      },
      hasMap(){
        return this.googleMap !== '';
      },
      hasStoreTour(){
        if(this.store.store_tour == ''){
          return false;
        }
        if(this.store.store_tour !== null){
          return true;
        }
        return false;
      },
      hasGooglePlace(){
        if(typeof this.store.google_place == 'undefined'){
          return false;
        }
        return this.store.google_place !== null;
      },
      googleMap(){
        if(this.hasGooglePlace && this.store.google_place != null){
          let place_id = encodeURIComponent(this.store.google_place);
          return '<iframe src="https://www.google.com/maps/embed/v1/place?key=AIzaSyB7D6J6Fq90RlWi2TdWsl_ogZn5oHPZuJ0&q=place_id:'+place_id+'" width="100%" height="550px" style="border:0;" allowfullscreen="" title="Google Map Embed of Local Tint World Store" referrerpolicy="no-referrer-when-downgrade"></iframe>';
          //return 'https://www.google.com/maps/embed/v1/place?key=AIzaSyB7D6J6Fq90RlWi2TdWsl_ogZn5oHPZuJ0&q=place_id:'+encodeURIComponent(this.store.google_place);
        }
        if(!this.hasGooglePlace && this.store.map_image){
          return '<img src="' + this.store.map_image + '" alt="Local Tint World Store Map" style="width:100%;height:550px;">';
        }
        return false;
      },
      hasStoreData(){
        if(this.store.google_place !== null){
          return true;
        }
        return false;
      },
      directionsUrl(){
        if(this.store.franconnect_id == null){
          return '';
        }
        return 'https://sync.tintworld.com/api/cache/store-directions?store_id='+encodeURIComponent(this.store.franconnect_id);
      },
      callablePhone(){
        if(this.store.phone_international !== null){
          return this.store.phone_international;
        }
        return '+18007678468';
      },
      displayPhone(){
        if(this.store.display_phone !== null){
          return this.store.display_phone;
        }
        if(this.store.phone !== null){
          return this.store.phone;
        }
        if(this.store.phone_international !== null){
          return this.store.phone_international;
        }
        return '1.800.767.8468';
      },
      activeMyStore(){
        if(this.my_store){
          return 'fa-heart';
        }
        return 'fa-heart-o';
      }
    },

  }
</script>

<template>
  <section id="store-info-module" class="mb-2">
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-6 map-elements-column">
          <div class="map-container" v-if="hasStoreData">
            <div id="mapDiv1" class="store-map-ctn text-center align-items-center" v-if="!toggle" v-html="googleMap">


            </div>
            <!-- @TODO - Add conditional logic where we'll disable the toggle or load fallback content as needed -->
            <div id="store-tour-container" v-if="toggle" v-html="store.store_tour"></div>
          </div>
          <div class="suspense-container text-center h-100" v-if="!hasStoreData">
            <div class="text-center align-items-center align-content-center h-100 suspense-loader">
              <div class="spinner-border text-info tw-spinner" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </div>

          <!-- @TODO - Add conditional logic where we'll disable the toggle or load fallback content as needed -->
          <div class="row text-center my-3" v-if="hasStoreTour">
            <div class="col-4 storeToggle1 storeToggleDown text-right m-0 p-0 custom-toggle" id="toggleText1" :class="{'tab-active':!toggle}">Store Map</div>
            <div class="col-4 m-0 p-0">
              <div class="custom-control custom-switch custom-switch-sm custom-switch-md custom-switch-lg custom-switch-xl">
                <input type="checkbox" class="custom-control-input" id="customSwitch1" v-model="toggle">
                <label class="custom-control-label" for="customSwitch1"></label>
              </div>
            </div>
            <div class="col-4 storeToggle1 storeToggleUp text-left m-0 p-0 custom-toggle" id="toggleText2" :class="{'tab-active':toggle}">Store Tour</div>
          </div>
        </div>
        <div class="col-12 col-md-6 store-info-column">
          <div class="row flex-nowrap my-store-section">
            <div class="col text-right flex-grow-0">
              <div class="heart-area c-pointer" @click="myStoreToggle" :class="{'active':my_store}">
                <i aria-hidden="true" class="fa fa-heart-o" :class="activeMyStore"></i>
                <p v-if="!my_store">Set as</p>
                <p>My Store</p>
              </div>
            </div>
            <div class="col flex-grow-1">
              <p class="store-name-number p-0 mb-0"><span class="storeTitle2">{{this.store.city}}, {{this.store.region_code}}</span> <span class="storeText1 noWrap">(Store #{{this.store.store_id}})</span></p>
              <div class="storeText2 mt-1">
                <i class="fas fa-phone-alt iconColor"></i>
                <a class="ml-2 store-phone-number" :href="'tel:'+callablePhone" title="Call This Tint World Store">{{this.displayPhone}}</a></div>
              <div class="storeText2 mt-1 d-flex align-items-center">
                <i class="fas fa-map-marker-alt iconColor"></i>
                <div class="ml-2 store-address">
                  <a class="get-directions-btn" :href="directionsUrl" title="Get Directions to This Store" target="_blank">
                  {{ fullAddress }}
                  </a>
                </div>
              </div>
              <div class="store-module-router d-flex flex-row align-items-center mt-1 flex-wrap">
                <i class="fas fa-globe-americas iconColor"></i>
                <div class="text-center ml-2 store-btn-wrap">
                  <a class="store-btn noWrap" :href="store.store_url" title="Click to Go to Store Website">Store Details & Offers</a>
                </div>
                <div class="text-center" v-if="store.facebook_url !== null">
                  <a class="social-link ml-1 mr-1" :href="store.facebook_url" target="_blank" title="Store Facebook Page"><i class="fab fa-facebook-f social-icon"></i></a>
                </div>
                <div class="text-center" v-if="store.instagram_url !== null">
                  <a class="social-link ml-1 mr-1" :href="store.instagram_url" target="_blank" title="Store Instagram Page"><i class="fab fa-instagram social-icon"></i></a>
                </div>
                <div class="text-center">
                  <a class="social-link ml-1 mr-1" href="https://youtube.com/tintworld" target="_blank" title="Brand Youtube"><i class="fab fa-youtube social-icon"></i></a>
                </div>
                <div class="text-center">
                  <a class="social-link ml-1 mr-1" href="http://twitter.com/tintworld" target="_blank" title="Brand X"><i class="fa-brands fa-x-twitter"></i></a>
                </div>
              </div>
            </div>
          </div>
          <div class="row storeBorder1 py-3 mt-4 mb-3 align-items-center flex-wrap">
            <div class="col-6 flex-grow-1 pl-0">
              <div class="storeTitle2">Hours:</div>
              <div class="storeText3 noWrap">Mon - Sat: <b>8am - 6pm</b></div>
              <div class="store-closed">Closed Sundays</div>
            </div>
            <div class="col-6 text-center mt-2 pr-0">
              <div><a href="#" @click="openQuoteModal" class="btn submit get-quote-btn" title="Get a Quote for Tint World Services">Get Quote</a></div>
            </div>
          </div>
          <div class="row">
            <div class="col-12"><div class="storeTitle2 mb-2">Store Amenities & Specialties:</div></div>
          </div>
          <div class="row mb-5">
            <div class="col-6">
              <div class="storeText3 mb-1"><i class="iconColor fas fa-wifi"></i> Free WiFi</div>
              <div class="storeText3 mb-1"><i class="iconColor fas fa-wheelchair"></i> Accessibile</div>
              <div class="storeText3 mb-1"><i class="iconColor fas fa-anchor"></i> Marine Services</div>
              <div class="storeText3 mb-1"><i class="iconColor fas fa-truck"></i> Oversized Vehicles</div>
            </div>
            <div class="col-6">
              <div class="storeText3 mb-1"><i class="iconColor fas fa-coffee"></i> Free Coffee & Snacks</div>
              <div class="storeText3 mb-1"><i class="iconColor fas fa-moon"></i> Overnight Drop-Off</div>
              <div class="storeText3 mb-1"><i class="iconColor fas fa-paw"></i> Pet Friendly</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
#store-info-module a {
  color: #028bff;
}
#store-info-module .store-btn {
  color: white;
  font-size: 12px;
  border-radius: 15px;
  background-color: #028bff;
  border: none;
  padding: 4px 10px 4px 10px;
  font-weight: 700;
}
.suspense-loader {
  border: 1px solid #ccc;
  border-radius: 25px;
}
.store-phone-number {
  font-size:18px;
}
#store-info-module .get-directions-btn {
  text-decoration: none;
  color: black;
  white-space: nowrap;
}
#store-info-module .get-directions-btn:hover {
  text-decoration: underline;
  color: #028bff;
}
#store-info-module .social-link .social-icon {
  font-size: 20px;
}
@media(max-width:412px) {
  .title1 { font-size:40px; }
  .subTitle1 { font-size: 20px; }
  .subTitle2 { font-size: 20px; }
  .h2Box { border: none; }
  .submit { font-size: 12px; padding: 5px 15px 8px 15px; }
  #storeAbout .storeText3, #storeAbout .storeText4 { display: none; }
  #storeHeadquarters h2, #PromosMobile h2 { line-height: 38px; }
  .carousel-inner { height: 390px; }
  #PromosMobile .carousel-inner { height: 370px; }
  .storeHeadquarters h4{ padding-top: 20px; }
  .storeBox2 { margin: 40px 0; height: 100%; }
  .installationSubTitle2 { text-align: center; }
  #Promos { height: 550px; }
  .styleBtn1, .styleBtn2 { font-size: 14px; }
  #PromosMobile .storeBox,  #PromosMobile .storeBox2  { width: 85%; margin: 0 auto; }
  .xpadding { padding-left: 30px; }
  .heart-area { width: 60px; height: 60px; }
}
@media(min-width:413px) {
  .title1 { font-size:40px; }
  .subTitle1 { font-size: 20px; }
  .storeTitle2 { font-size: 23px; }
  .h2Box { border: none; }
  .submit { font-size: 14px; padding: 5px 20px 8px 20px; }
  #storeAbout .storeText3, #storeAbout .storeText4 { display: none; }
  #storeHeadquarters h2, #PromosMobile h2 { line-height: 38px; }
  .carousel-inner { height: 390px; }
  #PromosMobile .carousel-inner { height: 370px; }
  .storeHeadquarters h4{ padding-top: 20px; }
  .storeBox2 { margin: 40px 0; height: 100%; }
  .installationSubTitle2 { text-align: center; }
  #Promos { height: 550px; }
  .styleBtn1, .styleBtn2 { font-size: 14px; }
  #PromosMobile .storeBox,  #PromosMobile .storeBox2  { width: 85%; margin: 0 auto; }
  .heart-area { width: 75px; height: 75px; }
}
@media(min-width:601px) {
  .title1 { font-size: 36px; }
  .subTitle1 { font-size: 20px; }
  .storeTitle2 { font-size: 23px; }
  .h2Box { border-bottom: 4px solid #dedede; }
  .submit { font-size: 14px; padding: 5px 15px 8px 15px; }
  .styleBtn1, .styleBtn2 { font-size: 10px; }
  #buyNow img { padding-top: 30px; }
  .storeBox2 { height: 100%; }
  .heart-area { width: 75px; height: 75px; }
}
@media(min-width:768px) {
  .title1 { font-size: 48px; }
  .subTitle1 { font-size: 26px; }
  .storeTitle2 { font-size: 23px; }
  .h2Box { border-bottom: 4px solid #dedede; }
  .heart-area { width: 75px; height: 75px; }
  .xpadding { padding-left: 30px; }
}
@media(min-width:992px) {
  .storeBox2 { height: 100%; }
  .storeTitle2 { font-size: 23px; }
  .heart-area { width: 75px; height: 75px; }
}
@media(min-width: 1200px) {
  .title1 { font-size: 52px; }
  .subTitle1 { font-size: 28px; }
  .storeTitle2 { font-size: 23px; }
  .h2Box { border-bottom: 6px solid #dedede; }
  .submit { font-size: 20px; padding: 5px 35px 8px 35px; }
  .carousel-inner { height: 350px; }
  #Promos { height: 500px; }
  .styleBtn1, .styleBtn2 { font-size: 14px; }
  .storeBox2 { height: 100%; }
  .heart-area { width: 75px; height: 75px; }
  }
#storeAbout, #Promos {
  background-color: #222222;
}
#storeHeadquarters, #buyNow {
  background-color: #ffe300;
}
#storeHeadquarters h2, #storeHeadquarters h4, #storeHeadquarters h2, #storeHeadquarters h3, #addServices h2, #addServices h3, #PromosMobile h2, #PromosMobile h3 {
  color: #000;
}
#storeHeadquarters h3, #storeHeadquarters p, #addServices h3, #PromosMobile h3  {
  color: #444444;
}
.storeTitle3, #storeAbout .storeText3, .subTitle2, #storeAbout h2, #storeAbout h3, #Promos h2, #Promos p {
  color: #FFF;
}
.subTitle3, .storeText4, #storeAbout p, #Promos h3 {
  color: #CCC;
}
#addServices, #reviewsTop, #reviews, #reviewsBottom, #PromosMobile, #PromosMobile .addCallout {
  background-color: #f1f1f1;
}
#addServices a, #PromosMobile a {
  color: #028aff;
}
.store-address, .storeText2 {
  font-size: 14px;
}
.custom-toggle {
  color: #7c7c7c
}
.heart-area {
  border-radius: 5px;
  border: 2px solid #acacac;
  background: transparent;
  color: #0992f1;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.heart-area.active {
  border: 0 solid #acacac;
  background: #0992f1;
  color: #fff;
}
.heart-area p {
  font-size: 13px;
  margin: 0;
  line-height: 1;
}
.c-pointer {
  cursor: pointer;
}
#store-tour-container {
  max-width: 100%;
  overflow: hidden;
  height: 100%;
  max-height: 100%;
}
#store-tour-container iframe {
  width: 100% !important;
  height: 100% !important;
}
#mapDiv1 iframe {
  max-height:550px !important;
  height: 100% !important;
}
#addServices {
  padding-top: 30px;
  padding-bottom: 30px;
}
#PromosMobile {
  padding-top: 30px;
  padding-bottom: 25px;
}
.title1 {
  text-transform: uppercase;
  font-weight:700;
  letter-spacing:-2px;
  line-height: 33px;
  color: #111111;
}
.subTitle1 {
  text-transform: uppercase;
  letter-spacing:-1px;
  color: #333;
  line-height: 23px;
}
.h2Box {
  padding-bottom: 30px;
  margin: 30px 0 30px 0;
}
.storeTitle2 {
  font-weight: bold;
}
.storeText1 {
  font-size: 13px;
  color: #555555;
}
.storeText3 {
  font-size: 16px;
}
.storeText4 {
  font-size: 14px;
  font-style: italic;
}
.storeToggle1 {
  font-size:22px;
  font-weight: bold;
}
.storeBorder1 {
  border-top: 2px solid #dedede;
  border-bottom: 2px solid #dedede;
}
.submit {
  border-radius: 25px;
  background-color: #028bff;
  color: #FFF !important;
  border: none;
  width: 95%;
  font-weight: 700;
  text-transform: uppercase;
}
.storeLink {
  border-radius: 15px;
  background-color: #028bff;
  color: #FFF !important;
  border: none;
  width: 150px;
  text-transform: uppercase;
  font-size: 10px;
  padding: 4px 10px 4px 10px;
  font-weight: 700;
}
.iconColor {
  color: #787878;
  padding-right: 5px;
}
#storeAbout {
  padding: 25px;
}
#storeAbout p {
  font-size: 18px;
  line-height: 30px;
}
#storeAbout h2 {
  border-left: 10px solid #ffe300;
  font-weight: 800;
  padding-left: 15px;
  text-transform: uppercase;
  font-size: 42px;
  line-height: 36px;
}
#buyNow h2 {
  border-left: 10px solid #e5cc00;
  font-weight: 800;
  padding-left: 15px;
  text-transform: uppercase;
  font-size: 42px;
  line-height: 36px;
}
#storeAbout h3 {
  font-weight: bold;
  font-size: 22px;
}
#storeAbout {
  padding-top: 50px;
  padding-bottom:30px;
}
#storeHeadquarters {
  padding-top: 30px;
  padding-bottom: 20px;
}
#storeHeadquarters h2, #addServices h2, #PromosMobile h2 {
  font-weight: 800;
  text-transform: uppercase;
  font-size: 42px;
}
#storeHeadquarters h3, #storeHeadquarters p, #addServices h3, #Promos h3, #PromosMobile h3 {
  font-size: 17px;
  font-weight: normal;
}
.storeBox, .storeBox2  {
  border-radius: 15px 15px 15px 15px;
}
.card-Link {
  font-size: 12px;
}
#storeHeadquarters .card-text, #addServices .card-text, #PromosMobile .card-text {
  font-size: 20px;
  font-weight: 800;
}
.card-Link {
  font-size: 14px;
  font-weight: normal;
}
.card-body2 {
  background-color: #191919;
  border-radius: 0 0 15px 15px;
  height: 80px;
}
.styleBtn1 {
  color: #FFF;
  padding:10px;
  border-radius: 10px;
  border: 2px solid #ffe300;
  font-weight: 700;
}
.styleBtn2 {
  color: #000;
  padding:10px;
  border-radius: 10px;
  border: 2px solid #CCC;
  font-weight: 700;
}
#contact-bar {
  padding-top: 20px;
  padding-bottom: 20px;
  background-color: #FFDD00;
}
#Promos {
  padding-top: 35px;
  padding-bottom: 30px;
}
#contact-bar h3.installationSubTitle2 {
  font-size: 26px;
  font-weight: 700;
  text-transform: capitalize;
  margin-top: 5px;
}
#reviewsTop {
  padding-top: 30px;
  padding-bottom: 10px;
}
#contact-bar h3 a {
  color: #028bff;
}
#reviewsTop h2, #Promos h2 {
  text-transform: uppercase;
  font-weight: 800;
  font-size: 48px;
  line-height: 45px;
}
.subTitle {
  font-size: 18px;
}
#buyNow {
  padding-top: 40px;
}
.storeToggleDown, .storeToggleUp {
  transition: color 0.3s ease-in-out;
}
.blackColor {
  color: black !important;
}
.grayColor {
  color: #7c7c7c !important;
}
.custom-toggle.tab-active {
  color: black !important;
}
.carousel-btn-L, .carousel-btn-R  {
  position: absolute;
  color: #FFF;
  top: 140px;
}
.carousel-btn-L {
  left: 40px;
}
.carousel-btn-R {
  right: 40px;
}
.carousel-btn-L {
  left:10px !important;
}
.carousel-btn-R {
  right:10px !important;
}
#storeHeadquarters a, .bottomQuote a, #storeInfo a {
  color: #007bff;
}
#storeHeadquarters a.btn, #PromosMobile a.carousel-btn-L, #PromosMobile a.carousel-btn-R {
  color: #000;
}
.custom-switch.custom-switch-sm .custom-control-label {
  padding-left: 1rem;
  padding-bottom: 1rem;
}

.custom-switch.custom-switch-sm .custom-control-label::before {
  height: 1rem;
  width: calc(1rem + 0.75rem);
  border-radius: 2rem;
}

.custom-switch.custom-switch-sm .custom-control-label::after {
  width: calc(1rem - 4px);
  height: calc(1rem - 4px);
  border-radius: calc(1rem - (1rem / 2));
}

.custom-switch.custom-switch-sm .custom-control-input:checked ~ .custom-control-label::after {
  transform: translateX(calc(1rem - 0.25rem));
}

/* for md */

.custom-switch.custom-switch-md .custom-control-label {
  padding-left: 2rem;
  padding-bottom: 1.5rem;
}

.custom-switch.custom-switch-md .custom-control-label::before {
  height: 1.5rem;
  width: calc(2rem + 0.75rem);
  border-radius: 3rem;
}

.custom-switch.custom-switch-md .custom-control-label::after {
  width: calc(1.5rem - 4px);
  height: calc(1.5rem - 4px);
  border-radius: calc(2rem - (1.5rem / 2));
}

.custom-switch.custom-switch-md .custom-control-input:checked ~ .custom-control-label::after {
  transform: translateX(calc(1.5rem - 0.25rem));
}

/* for lg */

.custom-switch.custom-switch-lg .custom-control-label {
  padding-left: 3rem;
  padding-bottom: 2rem;
}

.custom-switch.custom-switch-lg .custom-control-label::before {
  height: 2rem;
  width: calc(3rem + 0.75rem);
  border-radius: 4rem;
}

.custom-switch.custom-switch-lg .custom-control-label::after {
  width: calc(2rem - 4px);
  height: calc(2rem - 4px);
  border-radius: calc(3rem - (2rem / 2));
}

.custom-switch.custom-switch-lg .custom-control-input:checked ~ .custom-control-label::after {
  transform: translateX(calc(2rem - 0.25rem));
}

/* for xl */

.custom-switch.custom-switch-xl .custom-control-label {
  padding-left: 4rem;
  padding-bottom: 2.5rem;
}

.custom-switch.custom-switch-xl .custom-control-label::before {
  height: 2.5rem;
  width: calc(4rem + 0.75rem);
  border-radius: 5rem;
}

.custom-switch.custom-switch-xl .custom-control-label::after {
  width: calc(2.5rem - 4px);
  height: calc(2.5rem - 4px);
  border-radius: calc(4rem - (2.5rem / 2));
}

.custom-switch.custom-switch-xl .custom-control-input:checked ~ .custom-control-label::after {
  transform: translateX(calc(2.5rem - 0.25rem));
}
.directLink, .directLink2 {
  font-size:12px;
  font-style: italic;
}
.store-closed {
  font-size:12px;
  font-style: italic;
}
.noWrap {
  white-space: nowrap;
}
.get-quote-btn {

}
.store-map-ctn {
  height: 100%;
}
.suspense-loader {
  max-height: 90%;
  top:0;
}
.store-name-number {
  line-height: normal;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: baseline;
  vertical-align: text-top;
  position: relative;
  top: 0;
  margin-top: -7px;
}
.storeTitle2 {
  margin-right: 5px;
}
.my-store-section {
  align-items: flex-start;
}
.map-container {
  min-height: 450px;
  height: 450px;
}
@media(max-width: 767px){
  #store-info-module .map-container {
    min-height: 350px;
    height: 350px;
  }
  #store-info-module .store-info-column {
    margin-top: 25px;
  }
}
</style>